var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.625 105.375C298.125 92.875 277.875 92.875 265.375 105.375L137.375 233.375C124.875 245.875 124.875 266.125 137.375 278.625L265.375 406.625C277.875 419.125 298.125 419.125 310.625 406.625C316.875 400.375 320 392.188 320 384S316.875 367.625 310.625 361.375L237.25 288H416C433.688 288 448 273.688 448 256S433.688 224 416 224H237.25L310.625 150.625C323.125 138.125 323.125 117.875 310.625 105.375ZM32 64C14.312 64 0 78.312 0 96V416C0 433.688 14.312 448 32 448S64 433.688 64 416V96C64 78.312 49.688 64 32 64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftToLine);
export default __webpack_public_path__ + "static/media/arrow-left-to-line.3c21723bf72f3be7df18706dc434c2b2.svg";
export { ForwardRef as ReactComponent };